import { AxiosError } from 'axios';
export { AxiosError };

export interface ValidationErrorData {
    errors: Record<string, string[]>;
    status: 400;
    title: 'One or more validation errors occurred.';
}

export const isValidationError = (err: any): err is ValidationErrorData => {
    return err?.status === 400 && err.errors;
};
